/**
 * CORE-1436 — tell the server which time zone this device is in.
 *
 * Notification text is stored server-side as a finished string and the same
 * text goes out as a push, so the time inside it can only be right if the
 * server knows the reader's zone before sending. A profile zone is an explicit
 * choice and usually empty («по системе»); this is how «система» reaches the
 * server. Best-effort: once per signed-in user per app session, failures are
 * swallowed and retried on the next launch.
 */

const reported = new Set<string>();

export function getDeviceTimezone(): string | null {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof zone === 'string' && zone.length > 0 ? zone : null;
  } catch {
    return null;
  }
}

export async function syncDeviceTimezone(
  userId: string | null | undefined,
  send: (timezone: string) => Promise<void>,
): Promise<void> {
  if (!userId) return;
  const zone = getDeviceTimezone();
  if (!zone) return;
  const key = `${userId}|${zone}`;
  if (reported.has(key)) return;
  reported.add(key);
  try {
    await send(zone);
  } catch {
    reported.delete(key);
  }
}

/** Test-only: forget what was reported this session. */
export function resetDeviceTimezoneSync(): void {
  reported.clear();
}
